const LS_KEY_PREFIX = 'ccn-widget'
const LS_KEY_SEPARATOR = ':'

const buildKey = (key: string) => {
  return [LS_KEY_PREFIX, key].join(LS_KEY_SEPARATOR)
}

export const setLsItem = <T>(inKey: string, valueToStore?: T): void => {
  const key = buildKey(inKey)
  if (valueToStore !== undefined) {
    window.localStorage.setItem(
      key,
      typeof valueToStore === 'object' ? JSON.stringify(valueToStore) : String(valueToStore),
    )
  } else {
    window.localStorage.removeItem(key)
  }
}

export const getLsItem = <T>(inKey: string) => {
  const key = buildKey(inKey)
  const item = window.localStorage.getItem(key)

  try {
    return item ? (JSON.parse(item) as T) : undefined
  } catch {
    return item ? (item as unknown as T) : undefined
  }
}

export const findLsItems = <T>(keyPrefix: string) => {
  const fullPrefix = buildKey(keyPrefix)

  return Object.keys(window.localStorage).reduce<Record<string, T | undefined>>((acc, lsKey) => {
    if (!lsKey.startsWith(fullPrefix)) {
      return acc
    }

    const key = lsKey.replace(`${LS_KEY_PREFIX}${LS_KEY_SEPARATOR}`, '')
    const value = getLsItem<T>(key)

    acc[key] = value

    return acc
  }, {})
}

export const setLsAuthToken = (id: string, value?: string) => {
  setLsItem(`authToken:${id}`, value)
}

export const getLsAuthToken = (id: string) => {
  return getLsItem<string>(`authToken:${id}`)
}
